// Scoped bearer tickets let an anonymous design survive the normal sign-in
// session rotation. They confer only the right to claim that unowned design;
// the API additionally requires a verified account and rejects already-owned ones.
const storageKey = 'event-layout:anonymous-projects'
export function readClaims() {
  try {
    const values = JSON.parse(localStorage.getItem(storageKey) || '[]')
    return Array.isArray(values) ? values.filter(p => /^[a-f\d]{24}$/.test(p.id) && /^[a-f\d]{64}$/.test(p.claimTicket) && ['stage', 'video_wall'].includes(p.kind)).slice(0, 20) : []
  } catch { return [] }
}
export function rememberClaims(projects = []) {
  const values = new Map(readClaims().map(p => [p.id, p]))
  for (const p of projects) {
    if (p.savedToAccount) values.delete(p.id)
    else if (/^[a-f\d]{64}$/.test(p.claimTicket || '')) values.set(p.id, { id: p.id, name: p.name, kind: p.kind, claimTicket: p.claimTicket })
  }
  try { localStorage.setItem(storageKey, JSON.stringify([...values.values()].slice(-20))) } catch { /* The current session can still use its original design. */ }
  return readClaims()
}
export function forgetClaim(id) {
  const remaining = readClaims().filter(project => project.id !== id)
  try { localStorage.setItem(storageKey, JSON.stringify(remaining)) } catch { /* Storage may be disabled. */ }
  return remaining
}
